//Componentes generales
import React, { useReducer, useEffect, useContext } from "react";
import subsistemaReducer from "./subsistemaReducer";
import subsistemaContext from "./subsistemaContext";
import authContext from "../authentication/authContex";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getAllSubsistema, addSubsistema, updateSubsistema, deleteSubsistema } from "../../api/subsistema"

//Acciones
import { ACTUALIZAR_LIST_SUBSISTEMA} from "./subsistemaAction";

/* 
    State encargado de la gestión de productos.
*/
const SubsistemaState = props => {

    //Valores iniciales
    const initialState = {
        sistema: [],
    };

    const [state, dispatch] = useReducer(subsistemaReducer, initialState);
    const auContext = useContext(authContext);
    const {usuario} = auContext;
    
    const actualizarSubsistema = async () => {

        try{

            const resp = await getAllSubsistema();

            dispatch({
                type: ACTUALIZAR_LIST_SUBSISTEMA,
                payload: resp.data.data
            })

            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    const agregarSubsistema = async (dato) => {

        try{
            const resp = await addSubsistema(dato);
            const subsistema = resp.data.data;
            
            return subsistema;
        }catch(err){
            console.log(err);
            return null;
            
        }
        
    };

    const modificarSubsistema = async (dato) => {        
        try{            
            const resp = await updateSubsistema(dato);
            const subsistema = resp.data.data;            
            return subsistema;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarSubsistema = async (id) => {
        try{
            
            const resp = await deleteSubsistema(id);
            const subsistema = resp.data.data;
            
            return subsistema;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarSubsistema();
    },[usuario])

    return(
        <subsistemaContext.Provider
            value={{
                subsistema: state.subsistemaList,
                actualizarSubsistema,
                agregarSubsistema,
                modificarSubsistema,
                eliminarSubsistema
                
            }}
        >

            {props.children}

        </subsistemaContext.Provider>
    )
    
}

export default SubsistemaState;